<template>
  <!-- ВРАПЕР ДЛЯ РЕЖИМА РЕДАКТИРОВАНИЯ -->
  <dr-wrapper v-if="isInEditorMode" v-bind="$props" v-on="wrapOn">
    <div class="d-flex align-center">
      <span v-if="model.Caption" class="filtered-by-title mr-2">{{ model.Caption }}</span>
      <div
        class="add-new-filter ml-2"
      >
        <v-icon>mdi-plus</v-icon>
      </div>
    </div>
  </dr-wrapper>
  <!-- ДЛЯ РЕЖИМА ПРОИГРЫВАТЕЛЯ -->
    <div v-else>
      <div class="d-flex align-center">
        <span v-if="model.Caption" class="filtered-by-title mr-2">{{ model.Caption }}</span>
        <div v-if="listOfSelectedFilters.length" class="d-flex">
          <div v-for="(field, index) in listOfSelectedFilters" :key="field.name + index" class="ml-2">
            <v-menu offset-y :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                <div class="filter-name d-flex justify-space-between align-center">
                  <div>
                    <span 
                      class="filter-name-title"
                      :key="query[field.name]"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <span v-if="field.caption">{{ `${field.caption}: ${query[field.name] ? query[field.name] : ''}` }}</span>
                      <span v-else>{{ query[field.name] ? `${field.name}: ${query[field.name]}` : field.name  }}</span>
                    </span>
                  </div>
                  <div>
                    <v-btn icon @click="onDeleteFilter(field.name)">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </div>
                </div>
              </template>
              <v-list>
                <v-list-item>
                  <component 
                    :is="getComponentForQueryField(field.type)"
                    :value="query[field.name]"
                    @input="onInput(field.name, $event)"
                    @change="onChange(field, $event)"
                  />
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>
        <!-- интерфейс добавления нового фильтра -->
        <div class="add-new-filter-container">
          <v-menu offset-y :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <div
                class="add-new-filter ml-2"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon v-if="!isShowAutocomplete">mdi-plus</v-icon>
                <v-icon v-else>mdi-minus</v-icon>
              </div>
            </template>
            <v-list>
              <div class="dr-filter__selected-filters-wrapper d-flex flex-wrap">
                <div v-for="item in listOfSelectedFilters" :key="item.name" class="dr-filter__selected-filters-item">
                  {{ item.name }}
                </div>
              </div>
              <div class="mt-2">
                <v-list-item v-for="(autocompleteItem, autocompleteItemIndex) in autocompleteItems" :key="autocompleteItemIndex + autocompleteItem.text" class="pa-0">
                  <div :class="['dr-filter-autocomplete-item', { 'dr-filter-autocomplete-item-isActie': autocompleteItemIsActive(autocompleteItem) }]" @click="setAutocompleteItem(autocompleteItem)">
                    <input type="checkbox" :checked="autocompleteItemIsActive(autocompleteItem)" class="mr-5">
                    <span>
                      {{ autocompleteItem.text }}
                    </span>
                  </div>
                </v-list-item>
              </div>
            </v-list>
          </v-menu>
        </div>
        <!-- интерфейс добавления нового фильтра -->
      </div>
    </div>
</template>

<script>
import uk from '../../langs/drFilter/uk.json'
import ru from '../../langs/drFilter/ru.json'
import en from '../../langs/drFilter/en.json'
import baseMixin from '../../mixins/base-mixin'
import actionMixin from '../../mixins/actions-mixin'
import { widgetWrappersCollection } from '../../tools/widgetWrapper/widgetWrappersCollection'

export default {
  mixins: [baseMixin, actionMixin ],

  data: () => ({
    query: {},
    listOfSelectedFilters: [],
    isShowAutocomplete: false
  }),

  components: {
    'dr-filter-numeric-field': () => import('./dr-filter-numeric-field.vue'),
    'dr-filter-boolean-field': () => import('./dr-filter-boolean-field.vue')
  },

  computed: {
    autocompleteItems() {
      //формирование айтемов для автокомплита
      return this.model.Fields.map((e) => ({ text: e.caption ? e.caption : e.name, value: e }))
    },

    dataWidgetSourceRepository() {
      //получение WidgetSourceRepository указаного виджета
      return widgetWrappersCollection[this.model.DataWidget]?.getDataSourceRepository()
    }
  },

  methods: {
    getComponentForQueryField(type) {
      switch (type) {
        case 'string':
          return 'v-text-field'
        case 'number':
          return 'dr-filter-numeric-field'
        case 'boolean': 
          return 'dr-filter-boolean-field'
        default:
          return 'v-text-field'
      }
    },
    autocompleteItemIsActive(item) {
      //задаём класс isActive для айтема из списка доступных фильтров 
      const index = this.listOfSelectedFilters.findIndex((e) => e.name === item.text)
      if (index !== -1) {
        return true
      }

      return false
    },
    setAutocompleteItem(item) {
      const temInListIndex = this.listOfSelectedFilters.findIndex((e) => e.name === item.text)
      if (temInListIndex !== -1) {
        this.listOfSelectedFilters.splice(temInListIndex, 1)
        return
      }
      this.listOfSelectedFilters.push(item.value)
    },
    onChange() {
      //обновить фильтры для выбранного виджета
      if (this.dataWidgetSourceRepository !== undefined) {
        this.dataWidgetSourceRepository.setFilters(this.query)
        this.dataWidgetSourceRepository.refresh()
      }
    },
    onDeleteFilter(field) {
      //удалить qury
      if (this.query[field]) {
        delete this.query[field]
      }
      //удалить текущий фильтр из списка выбранных
      const index = this.listOfSelectedFilters.findIndex((e) => e.name === field)
      this.listOfSelectedFilters.splice(index, 1)

      //обновить фильтры для выбранного виджета
      if (this.dataWidgetSourceRepository !== undefined) {
        this.dataWidgetSourceRepository.setFilters(this.query)
        this.dataWidgetSourceRepository.refresh()
      }
    },
    async onInput(field, value) {
      this.$set(this.query, field, value)
    }
  },
  i18n: {
    messages: {
      uk, ru, en
    }
  }
}
</script>

<style>
  .filter-name-title {
    font-size: 12px;
    font-weight: 600;
    color: #000000;
  }
  .add-new-filter-container {
    position: relative;
    height: 100px;
    display: flex;
    align-items: center;
  }
  .filtered-by-title {
    font-size: 20px;
    font-weight: 600;
  }
  .filter-name {
    display: flex;
    justify-content: center;
    border: 2px solid #D1D2D2;
    background: #F6F6F6;
    min-width: 60px;
    padding: 12px 0px 12px 16px;
    border-radius: 30px;
    height: 40px;
  }
  .add-new-filter {
    background: #E8E9EC;
    height: 40px;
    display: flex;
    align-items: center;
    width: 40px;
    justify-content: center;
    border-radius: 5px;
    cursor: pointer;
  }
  .dr-filter-autocomplete-item {
    width: 100%;
    height: 50px;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 0 10px;
  }
  .dr-filter-autocomplete-item-isActie {
    background: #e4edf8;
    color: #1867c0
  }
  .dr-filter-autocomplete-item:hover {
    background: rgb(197, 197, 197);
  }
  .dr-filter__selected-filters-wrapper {
    border: 1px solid #3333;
    min-height: 42px;
    width: 200px;
    padding: 5px 10px;
    margin: 0 10px;
  }
  .dr-filter__selected-filters-item {
    background: rgb(207, 207, 207);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    border-radius: 5px;
    margin-right: 4px;
    margin-top: 3px;
    height: 23px;
  }
</style>